// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    dirty: false,
    raw: "b94c2c3",
    hash: "b94c2c3",
    distance: null,
    tag: null,
    semver: null,
    suffix: "b94c2c3",
    semverString: null,
    subenv: null,
    rev_count: "1"
};
/* tslint:enable */
